import React from "react";
import cx from "classnames";
import Subtract from "../../../assets/images/verboden/subtract.svg";
import VS from "../../../assets/images/verboden/VS.png";
import Alert from "../../../components/shared/common/alert";
import { Container, Row, Col, Button } from "reactstrap";

import { connect } from "react-redux";
import PlayerCard from "./playerCard";
import Socket from "../../../socket/socket";
import _ from "lodash";

const TeamCard = (props) => {
  const {
    title = "",
    type = "first",
    players = [],
    roomUsers,
    teamData
  } = props;
  const teamPlayers = players;
  let totalPlayers = teamPlayers.length;

  return (
    <div className={cx("teamColWrapper", type)}>
      <div className="team-col">
        <div className="d-flex justify-content-between align-items-center mb-2">
          <h2 className="text-orange mb-0">{title}</h2>
          <p className="text mb-0 mr-2" style={{paddingRight: '1.5rem'}}>{`Players: ${teamPlayers.length}/6`}</p>
        </div>
        <div className="team-list-wrap">
          {teamPlayers.map((data, index) => {
            const playerOfTeam = roomUsers.find(
              (user) => user.player_id === data
            );
            return <PlayerCard key={index} data={playerOfTeam} type={type} />;
          })}
        </div>
      </div>
    </div>
  );
};

class Team extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      allusers: [],
      audioUrl: {}
    };
  }
  static comparer = (otherArray) => {
    return function (current) {
      return (
        otherArray.filter(function (other) {
          return other.player_id === current.player_id;
        }).length === 0
      );
    };
  };
  playAudio = (url) => {
    var audio = document.createElement("audio");
    audio.src = url;
    audio.style.display = "none";
    audio.autoplay = true;
    audio.onended = function () {
      audio.remove();
    };
    document.body.appendChild(audio);
  };
  componentDidUpdate() {
    let roomObj = this.props.gameReducer.roomObj;

    if (
      this.props.usersChanged &&
      Object.keys(roomObj).length > 0 &&
      roomObj.users.length > 0
    ) {
      if (roomObj.users.length > this.state.allusers.length) {
        /* const callAudioEl = document
          .getElementById("callAudio")
          .cloneNode(true); */

        let result = roomObj.users.filter(Team.comparer(this.state.allusers));
        this.setState(
          {
            allusers: roomObj.users,
            audioUrl:
              result && result[0].audio_effect ? result[0].audio_effect : ""
          },
          () => {
            this.playAudio(this.state.audioUrl);
            /* if (callAudioEl) {
              callAudioEl
                .play()
                .then(() => {})
                .catch(() => {});
              setTimeout(() => {
                callAudioEl.pause();
                callAudioEl.currentTime = 0;
              }, 2000);
            } */
          }
        );
      }
    }
    if (
      Object.keys(roomObj).length > 0 &&
      roomObj.users.length < this.state.allusers.length
    ) {
      this.setState({
        allusers: roomObj.users
      });
    }
  }

  componentDidMount() {
    console.log("didmount call");
    // const teamChange = this.props?.loaderDetails?.changeTeam
    // if(teamChange){
    this.removeListener = Socket.addListener("change-team-vb", (res) => {
      console.log(res, "call arrow clickkkk response");
      if (res) {
        const player = _.find(res.room.users, { player_id: res.playerId });
        console.log(player, "playerplayerplayerplayer");
        Alert(200, `${player.display_name}'s team changed successfully`);
        // setTimeout(() => {
        //   this.props.setChangingTeam(false);
        // }, 10);
      }
    });
    // }
  }
  componentWillUnmount() {
    this.removeListener();
  }

  render() {
    let roomData = this.props.gameReducer.roomObj;
    let playersText = "Players";
    let teamALabel = "Team A";
    let teamBLabel = "Team B";
    if (this.props.paramsReducer && this.props.paramsReducer.gameObj) {
      let gameObj = this.props.paramsReducer.gameObj;

      if (gameObj && gameObj.screens && gameObj.screens.lobby) {
        teamALabel = gameObj.screens.lobby.teams_label_a;
        teamBLabel = gameObj.screens.lobby.teams_label_b;

        playersText = gameObj.screens.lobby.teams_player_label_a;
      }
    }
    let roomUsers = [];
    if (roomData && roomData.users && roomData.users.length > 0) {
      roomUsers = roomData.users;
    }

    let teams = [];
    let team1PlayerIds = [];
    let team1Data = {};
    let team2Data = {};
    let team2PlayerIds = [];
    if (
      roomData &&
      roomData.game_state &&
      roomData.game_state.teams &&
      roomData.game_state.teams.length > 0
    ) {
      teams = roomData.game_state.teams;
      if (roomData.game_state.teams[0]) {
        team1Data = roomData.game_state.teams[0];
        team1PlayerIds = roomData.game_state.teams[0].team_queue;
      }
      if (roomData.game_state.teams[1]) {
        team2Data = roomData.game_state.teams[1];
        team2PlayerIds = roomData.game_state.teams[1].team_queue;
      }
    }

    return (
      <div className="position-relative d-flex flex-column flex-grow-1">
        {/* <div className="d-flex justify-content-between ">
          <h1 className="title text">Teams</h1>
          <p className="text">{`Players: ${roomUsers.length}/12`}</p>
        </div> */}
        <div className="d-flex h-100">
          <TeamCard
            type="first"
            title={teamALabel}
            players={team1PlayerIds}
            teamData={team1Data}
            roomUsers={roomUsers}
          />
          <div className="text-orange vs-image">
            {/* <img src={Subtract} /> */}
            <img src={VS} />
          </div>
          <TeamCard
            type="second"
            title={teamBLabel}
            players={team2PlayerIds}
            teamData={team2Data}
            roomUsers={roomUsers}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  gameReducer: state.gameReducer,
  loaderDetails: state.loaderDetails,
  paramsReducer: state.paramsReducer
});

export default connect(mapStateToProps, null)(Team);
